// Dashboard constants
export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('es-GT', {
    style: 'currency',
    currency: 'GTQ',
  }).format(amount);
};
